var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("Card", {
        attrs: { title: "Artist Application Detail" },
        scopedSlots: _vm._u([
          {
            key: "button",
            fn: function() {
              return [
                _c("Button", {
                  attrs: { variant: "default", label: "Back" },
                  on: { clicked: _vm.goBack }
                }),
                _vm._v(" "),
                _vm.canReview
                  ? _c("Button", {
                      attrs: { variant: "primary", label: "Approve" },
                      on: { clicked: _vm.approve }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.canReview
                  ? _c("Button", {
                      attrs: { variant: "primary", label: "Reject" },
                      on: { clicked: _vm.openReject }
                    })
                  : _vm._e()
              ]
            },
            proxy: true
          },
          {
            key: "body",
            fn: function() {
              return [
                _c("div", { staticClass: "w-full" }, [
                  _c(
                    "div",
                    {
                      staticClass: "flex flex-col py-6",
                      staticStyle: { "min-width": "600px" }
                    },
                    [
                      _c("div", { staticClass: "flex flex-col mb-6" }, [
                        _c(
                          "span",
                          {
                            class: _vm.statusBadgeClass(_vm.application.status)
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.statusLabel(_vm.application.status))
                            )
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "flex flex-wrap" }, [
                        _c(
                          "div",
                          { staticClass: "w-1/2 pr-4" },
                          [
                            _c("form-item", {
                              attrs: { label: "First Name" },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function() {
                                    return [
                                      _c(
                                        "p",
                                        { staticClass: "text-left font-bold" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.application.first_name)
                                          )
                                        ]
                                      )
                                    ]
                                  },
                                  proxy: true
                                }
                              ])
                            }),
                            _vm._v(" "),
                            _c("form-item", {
                              attrs: { label: "Last Name" },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function() {
                                    return [
                                      _c(
                                        "p",
                                        { staticClass: "text-left font-bold" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.application.last_name)
                                          )
                                        ]
                                      )
                                    ]
                                  },
                                  proxy: true
                                }
                              ])
                            }),
                            _vm._v(" "),
                            _c("form-item", {
                              attrs: { label: "Email" },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function() {
                                    return [
                                      _c(
                                        "p",
                                        { staticClass: "text-left font-bold" },
                                        [_vm._v(_vm._s(_vm.application.email))]
                                      )
                                    ]
                                  },
                                  proxy: true
                                }
                              ])
                            }),
                            _vm._v(" "),
                            _c("form-item", {
                              attrs: { label: "Phone Number" },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function() {
                                    return [
                                      _c(
                                        "p",
                                        { staticClass: "text-left font-bold" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.application.phone_number)
                                          )
                                        ]
                                      )
                                    ]
                                  },
                                  proxy: true
                                }
                              ])
                            }),
                            _vm._v(" "),
                            _c("form-item", {
                              attrs: { label: "Monetize Choice" },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function() {
                                    return [
                                      _c(
                                        "p",
                                        { staticClass: "text-left font-bold" },
                                        [_vm._v(_vm._s(_vm.monetizeLabel))]
                                      )
                                    ]
                                  },
                                  proxy: true
                                }
                              ])
                            }),
                            _vm._v(" "),
                            _c("form-item", {
                              attrs: { label: "Submitted" },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function() {
                                    return [
                                      _c(
                                        "p",
                                        { staticClass: "text-left font-bold" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.application.submitted_at)
                                          )
                                        ]
                                      )
                                    ]
                                  },
                                  proxy: true
                                }
                              ])
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "w-1/2 pr-4" },
                          [
                            _c("form-item", {
                              attrs: {
                                label: "Adventist Union / Conference / Mission"
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function() {
                                    return [
                                      _c(
                                        "p",
                                        { staticClass: "text-left font-bold" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.application.missions)
                                          )
                                        ]
                                      )
                                    ]
                                  },
                                  proxy: true
                                }
                              ])
                            }),
                            _vm._v(" "),
                            _c("form-item", {
                              attrs: { label: "Church Name" },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function() {
                                    return [
                                      _c(
                                        "p",
                                        { staticClass: "text-left font-bold" },
                                        [_vm._v(_vm._s(_vm.application.church))]
                                      )
                                    ]
                                  },
                                  proxy: true
                                }
                              ])
                            }),
                            _vm._v(" "),
                            _c("form-item", {
                              attrs: { label: "Demo Links" },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function() {
                                    return [
                                      _c(
                                        "p",
                                        {
                                          staticClass:
                                            "text-left font-bold whitespace-pre-line"
                                        },
                                        [_vm._v(_vm._s(_vm.application.links))]
                                      )
                                    ]
                                  },
                                  proxy: true
                                }
                              ])
                            }),
                            _vm._v(" "),
                            _c("form-item", {
                              attrs: { label: "Self Introduction" },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function() {
                                    return [
                                      _c(
                                        "p",
                                        {
                                          staticClass:
                                            "text-left font-bold whitespace-pre-line"
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.application.self_introduction
                                            )
                                          )
                                        ]
                                      )
                                    ]
                                  },
                                  proxy: true
                                }
                              ])
                            }),
                            _vm._v(" "),
                            _c("form-item", {
                              attrs: { label: "Legal Accepted At" },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function() {
                                    return [
                                      _c(
                                        "p",
                                        { staticClass: "text-left font-bold" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.application.legal_accepted_at
                                            )
                                          )
                                        ]
                                      )
                                    ]
                                  },
                                  proxy: true
                                }
                              ])
                            })
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _vm.application.status === "REJECTED" &&
                      _vm.application.rejection_reason
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "w-full mt-4 p-4 bg-red-50 border border-red-200 rounded"
                            },
                            [
                              _c("form-item", {
                                attrs: { label: "Rejection Reason" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function() {
                                        return [
                                          _c(
                                            "p",
                                            {
                                              staticClass:
                                                "text-left font-bold text-red-700"
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.application
                                                    .rejection_reason
                                                )
                                              )
                                            ]
                                          )
                                        ]
                                      },
                                      proxy: true
                                    }
                                  ],
                                  null,
                                  false,
                                  855454235
                                )
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "w-full mt-6" },
                        [
                          _c("form-item", {
                            attrs: { label: "Uploaded Files" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function() {
                                  return [
                                    _vm.files.length === 0
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "text-left text-gray-500"
                                          },
                                          [_vm._v("No files attached.")]
                                        )
                                      : _c(
                                          "ul",
                                          { staticClass: "text-left" },
                                          _vm._l(_vm.files, function(file) {
                                            return _c(
                                              "li",
                                              {
                                                key: file.id,
                                                staticClass:
                                                  "flex items-center justify-between py-2 border-b border-gray-100"
                                              },
                                              [
                                                _c("div", [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "inline-block px-2 py-1 mr-2 text-xs font-bold rounded bg-gray-200"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          file.type.toUpperCase()
                                                        )
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass: "font-bold"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          file.original_name
                                                        )
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "text-gray-500 ml-2 text-xs"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.humanFileSize(
                                                            file.size
                                                          )
                                                        )
                                                      )
                                                    ]
                                                  )
                                                ]),
                                                _vm._v(" "),
                                                _c("Button", {
                                                  attrs: {
                                                    variant: "default",
                                                    label: "Download"
                                                  },
                                                  on: {
                                                    clicked: function($event) {
                                                      return _vm.downloadFile(
                                                        file
                                                      )
                                                    }
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          }),
                                          0
                                        )
                                  ]
                                },
                                proxy: true
                              }
                            ])
                          })
                        ],
                        1
                      )
                    ]
                  )
                ])
              ]
            },
            proxy: true
          }
        ])
      }),
      _vm._v(" "),
      _c(
        "ModalDialog",
        {
          ref: "rejectionModal",
          attrs: {
            isShowingModal: _vm.isShowingModalReject,
            isLoading: _vm.isLoading,
            error: _vm.isError,
            labelSubmit: "Submit Rejection",
            title: "Reject Application"
          },
          on: {
            toggleModal: function($event) {
              _vm.isShowingModalReject = !_vm.isShowingModalReject
            },
            save: function($event) {
              return _vm.submitRejected()
            }
          }
        },
        [
          _c(
            "template",
            { slot: "body" },
            [
              _c("RejectionForm", {
                ref: "rejectionForm",
                attrs: {
                  "toggle-reset": _vm.isShowingModalReject,
                  "song-rejection": _vm.rejectionTarget,
                  "custom-submit": _vm.customReject
                },
                on: { "on-submit-rejection": _vm.onSubmitRejectionForm }
              })
            ],
            1
          )
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-522d6e1a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-522d6e1a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/ArtistContent/ArtistApplicationDetail.vue
// module id = null
// module chunks = 